import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MeetingAgendaCard from 'Components/UI/MeetingAgendaCard';
import Typography from 'Components/UI/Typography';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { useRefreshMissionControLiveEmail } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';

const styles = (theme) => ({
  root: {
    margin: theme.spacing(1),
  },
  cards: {
    // width: '50%',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(1),
  },
});

const View = ({
  className,
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();
  const { displayErrorMessage } = useSnackbarContext();
  const [meetingAgendaCollection, setMeetingAgendaCollection] = useState(null);
  const eventTrackingLogEventProps = useEventTrackingLogEvent({ nodeName: 'MC Scheduled Meeting Agendas' });

  useEffect(() => {
    if (!householdResource?.relationship(fr.relationships.scheduledMeetingAgendas.name)) {
      return;
    }

    async function getScheduledEmails() {
      const coll = await householdResource.relationship(fr.relationships.scheduledMeetingAgendas.name).link('related').get();
      setMeetingAgendaCollection(coll);
    }
    getScheduledEmails();
  }, [householdResource]);

  const refreshMeetingAgendas = async () => {
    try {
      const coll = await meetingAgendaCollection.refresh();
      setMeetingAgendaCollection(coll);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  useRefreshMissionControLiveEmail(() => {
    refreshMeetingAgendas();
  }, [meetingAgendaCollection]);

  if (!meetingAgendaCollection) return null;
  return (
    <div
      className={classNames(classes.root, className)}
    >
      <Typography color="primary" variant="h2" className={classes.title}>Scheduled Emails</Typography>
      <div className={classes.cards}>
        {meetingAgendaCollection.resources().list().map(el => (
          <MeetingAgendaCard meetingAgendaResource={el} refreshCollection={refreshMeetingAgendas} {...eventTrackingLogEventProps} />
        ))}
      </div>
    </div>
  );
};

View.defaultProps = {
  className: '',
};

View.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
